import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Table from 'shared/migration-components/table';
import {DistanceProps} from 'modules/cities/types';
import QueryDeleteButton from 'shared/migration-components/query-delete-button';
import useCompanyDistances from 'modules/companies/hooks/use-company-distances';
import companiesKeys from 'modules/companies/util/companies-keys';
import toBrl from 'shared/util/to-brl';

const Distances: React.FC = () => {
  const {id} = useParams();
  const {data = [], isLoading} = useCompanyDistances(id!);
  const navigate = useNavigate();

  return (
    <Table<DistanceProps>
      loading={isLoading}
      {...{data}}
      options={[
        {
          value: 'operator',
          column: (data) => (data.operator === 'gt' ? 'Maior que' : 'Até'),
        },
        'distance',
        {
          value: 'deliveryPrice',
          column: (data) => data.deliveryPrice && toBrl(data.deliveryPrice),
        },
        {
          value: 'deliveryManFee',
          column: (data) => data.deliveryManFee && toBrl(data.deliveryManFee),
        },
        {
          value: 'id',
          column: (row) => (
            <QueryDeleteButton
              queryKey={companiesKeys.distances(id!)}
              url={`/distances/${row.id}`}
              type="update"
            />
          ),
        },
      ]}
      translatedPropsKey="DistanceProps"
      onRowClick={(row) => navigate('create', {state: row})}
    />
  );
};

export default Distances;
